import Ajax from '@/lib/ajax'

export default {
  getAll() {
    return Ajax.get('/api/MallConfigManagement/NavigationBar/All')
  },
  deleteById(id: string | number) {
    return Ajax.delete(`/api/MallConfigManagement/NavigationBar?id=${id}`)
  },
  edit(id: string | number, editData: any) {
    let ajaxType = id ? 'put' : 'post'
    let ajaxUrl = id
      ? `/api/MallConfigManagement/NavigationBar?id=${id}`
      : '/api/MallConfigManagement/NavigationBar'
    return Ajax[ajaxType](ajaxUrl, editData)
  },
  getDataById(id: string | number) {
    return Ajax.get(`/api/MallConfigManagement/NavigationBar/${id}`)
  },
  getTreeData() {
    return Ajax.get('/api/MallConfigManagement/NavigationBar/tree')
  }
}
